import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const receivingKpis /*: WarehouseKPI[] */ = [
  {
    id: 'receiving_accuracy',
    processType: ActivityEventProcessType.RECEIVING,
    category: 'process',
    title: 'Receiving Accuracy',
    description:
      'Percentage of items received correctly (quantity, condition, SKU)',
    unit: '%',
    formula:
      '(1 - (COUNT(receiving_exceptions) / COUNT(received_items))) * 100',
    tags: ['receiving', 'quality', 'iso-22400:QAS'],
    benchmark: {
      standards: {
        site: {
          target: 99.5,
          warning: { lower: 98.5 },
          critical: { lower: 97 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 97 },
            { label: 'Warning', min: 97.01, max: 98.5 },
            { label: 'Target', min: 98.51, max: 99.5 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['supplier_id', 'item_category', 'receiver_id'],
    alertTopic: 'warehouse.alerts.process.receiving',
  },
  {
    id: 'receipt_processing',
    processType: ActivityEventProcessType.RECEIVING,
    category: 'process',
    title: 'Receipt Processing',
    description: 'Average time to process receipts',
    unit: 'min',
    formula: 'AVG(receipt_processing_time)',
    tags: ['receiving', 'processing'],
    benchmark: {
      standards: {
        site: {
          target: 45,
          warning: { upper: 60 },
          critical: { upper: 90 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 45 },
            { label: 'Warning', min: 45.01, max: 60 },
            { label: 'Target', min: 60.01, max: 90 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['dock_id', 'shift'],
    alertTopic: 'warehouse.alerts.process.receipt_processing',
  },
];

export default receivingKpis;
